import {Select, MenuItem} from "@mui/material";
import {Member} from "../members/types";

type Props = {
    members: Member[];
    member: Member;
    setSelectedMember: (value: Member) => void;
};

export default (props: Props) => (
    <Select
        value={props.member ? props.member.numberId : "all"}
        margin="dense"
        variant="outlined"
        onChange={(ev) => {
            if (ev.target.value == "all") props.setSelectedMember(null);
            else props.setSelectedMember(props.members.find((m: Member) => m.numberId == ev.target.value));
        }}
    >
        <MenuItem key="all" value="all">
            All
        </MenuItem>
        {props.members.map((m) => (
            <MenuItem key={m.numberId} value={m.numberId}>
                {m.number.extension.displayName} ({m.number.shortNumber})
            </MenuItem>
        ))}
    </Select>
);
